<div class="content-wrapper container-xxl p-0">
    <loader *ngIf="showLoader"></loader>
    <div class="content-body">
        <div class="card">
            <div class="card-body">


                <div class="row">
                    <div [ngClass]="(addOnOrderData.orderType === 'CLAIM' && isLoungeSelected) ? 'col-md-6': 'col-12'">
                        <div class="row m-0">
                            <div class="col-12">
                                <h4 class="textBlue ">{{ addOnOrderData.orderType == 'BUY' ? 'Buy' : 'Claim' }} International Lounge Access</h4>
                            </div>
                            <div class="col-12">
                                <p class=""><strong>Searched City</strong></p>
                            </div>

                            <div class="col-12 col-md-4">
                                <div class="input-group city-search">
                                    <span>
                                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Search for City" [(ngModel)]="searchCityName" (input)="filterCities($event.target.value)" />
                                    <i class="fa fa-times position-absolute" *ngIf="isCitySelected"  style="right: 10px;cursor: pointer;z-index: 100;" (click)="clearCitySelection()"></i>
                                </div>
                            </div>

                        </div>
                        <div class="row p-0 lounge-cities-container">  
                            <div class="col-6 col-md-2 lounge-cities" *ngFor="let singleItem of filteredCities"> 
                                    <div class="d-flex align-items-center align-items-md-center" style="flex-direction: column;" (click)="getLounge(singleItem)" [ngClass]="{'selectedCity': ((selectedCity) ? (singleItem.title == selectedCity?.title) : false) }">
                                        <span *ngIf="singleItem.title == selectedCity?.title" class="selected-city-check"></span>
                                        <img src="assets/images/lounge-access/{{singleItem.icon}}">
                                        <div class="fs-14 fw-600" class="lounge-city-text">
                                            {{ singleItem.title }}
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="col-12" *ngIf="isCitySelected">
                            <p class=""><strong>Available Lounges at {{ searchCityName }}</strong></p>
                        </div>


                        <div class="row mt-6 lounge-container" *ngIf="isCitySelected">  
                            <div class="single-lounge" [ngClass]="(addOnOrderData.orderType === 'CLAIM' && isLoungeSelected ) ? 'col-md-3': 'col-md-2'" *ngFor="let lounge of loungeList"> 
                                <div class="d-flex align-items-center align-items-md-start" style="flex-direction: column;" (click)="selectLounge(lounge)" [ngClass]="{'selectedLounge': ((selectedLounge) ? (lounge.outletId == selectedLounge?.outletId) : false) }">
                                    <span *ngIf="lounge.outletId == selectedLounge?.outletId" class="selected-lounge-check"></span>
                                    <img src="assets/images/lounge-access/{{ lounge.index > 1 ? 0 : lounge.index }}.png">
                                    <div class="lounge-text">
                                        <p class="p-0 m-0 fs-12 fw-500 text-center">{{ lounge.outletName }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" *ngIf="addOnOrderData.orderType === 'CLAIM' && isLoungeSelected">
                        
                        <div class="col-12">
                            <p>Claim Free Lounge Access</p>
                        </div>
                        <div class="col-12">                        
                            <div class="card">
                                <div class="card-body product-info-box">
                                    <div class="row p-0 m-0">
                                        <div class="col-12 col-md-12 product-details">
                                            <div class="row m-0">
                                                <div class="col-12 col-md-6">
                                                    <h5 class="textBlue">Lounge Access</h5>
                                                    <p class="fs-10 m-0"></p>
                                                </div>
                                                <div class="col-12 col-md-6 text-right">
                                                    <p>
                                                        <s class="old-price">₹ {{ selectedLounge.basePrice }} </s> 
                                                        <strong class="new-price fs-18">Free</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-12 lounge-access-benefits" style="background: #F3F3F3;">
                                            <div class="row m-0">
                                                <div class="col-12 col-md-4 pl-0 text-left">Premium Facilities</div>
                                                <div class="col-12 col-md-4 text-center">Free WiFi</div>
                                                <div class="col-12 col-md-4 pr-0 text-right">Complimentary Food</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-6 lounge-container">
                    <div class="col-12">  
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" [(ngModel)]="isTermsAccepted">
                            <label class="form-check-label" for="flexCheckDefault">
                                I agree to the Terms & Conditions, acknowledging that this product is offered by WSFx in collaboration with DreamFolks and is subject to the companies’ policies.
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row"> 
                    <div class="col-12 text-right" *ngIf="isCitySelected">
                        <button class="btn btn-proceed" (click)="proceedToBuy()">Proceed</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #loungePassCardModal let-modal>
    <div class="modal-header">
        <h6 class="modal-title" id="myModalLabel1"></h6>
        <button type="button" class="close" (click)="closeModalAndNavigate()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="success-img" style="width: 100%; text-align: center;">
            <img src="assets/images/lounge-access/success.gif" class="success-img" >
        </div>
        <p class="link-text">Congratulations!</p>
        <p class="link1-text">
         You've successfully claimed your free lounge access. Enjoy a peaceful break before your journey!
        </p>
       
        <div class="row">
        <div class="col-md-12 col-12 mt-20 text-center">
            <button type="button" rippleEffect class="btn-linkcard1 btn-block" (click)="downloadLoungPass()">View Lounge pass</button><!-- openLoungPass() -->
        </div>
    </div>
    </div>
  </ng-template>
  <ng-template #loungeDocumentViewModal let-modal>
    <div class="modal-header">
        <h6 class="modal-title" id="myModalLabel1"></h6>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="col-md-12" *ngIf="this.passUrl !== ''">
            <iframe [src]="transform()" style="height:400px;display:block;width:100%;"></iframe>
        </div>
    </div>
</ng-template>